module.exports = __webpack_public_path__ + "img/stuhrwerk_logo.45684ea2.svg";